module.exports = __webpack_public_path__ + "assets/img/25_397_big.c4a66ea8.jpg";